import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref, watch } from 'vue'
  import SVGRenderer from '@/components/common/SVGRenderer.vue'
  import useBreakpoint from '@/composables/useBreakpoint'
  import useSegment from '@/composables/useSegment'
  import useIcons from '@/composables/useIcons'
  import { useRoute, useRouter } from 'vue-router/composables'
  import { vOnClickOutside } from '@vueuse/components'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'Search',
  props: {
    openSidePanel: {
      type: Boolean,
      default: false,
    },
    inSidePanel: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['close-side-panel', 'create-space-for-search-input'],
  setup(__props, { emit }) {

const props = __props;

  

  

  const router = useRouter()
  const route = useRoute()
  const { isMobileDevice, isSmallerMobileDevice } = useBreakpoint()
  const { contentTermSearched } = useSegment()
  const { closeIcon, searchIcon } = useIcons()
  const searchTerm = ref('')
  const hovering = ref(false)
  const expandSearch = ref(false)
  const showSearchTooltip = ref(false)
  const searchingFromSidePanel = ref(false)
  const searchInput = ref(null as HTMLInputElement | null)

  const routeQuery = computed(() => {
    return route.query
  })

  const findSearchTerm = (searchingFromSidePanel: boolean) => {
    if (searchTerm.value.length < 3) {
      checkToShowSearchTooltip(searchingFromSidePanel)
      return
    }
    if (props.openSidePanel) emit('close-side-panel')
    contentTermSearched(searchTerm.value)
    if (searchTerm.value === route.query.q) return
    router
      .push({
        name: 'SearchResults',
        query: { q: searchTerm.value },
      })
      .catch(() => {
        return
      })
  }

  const checkToShowSearchTooltip = (isSearchingFromSidePanel: boolean) => {
    if (isSearchingFromSidePanel) {
      searchingFromSidePanel.value = true
    }
    showSearchTooltip.value = true
    setTimeout(() => {
      showSearchTooltip.value = false
    }, 4000)
  }

  const expandSearchInput = () => {
    if (isSmallerMobileDevice.value) {
      emit('create-space-for-search-input', true)
    }
    expandSearch.value = true
    searchInput.value?.focus()
  }

  const clearSearch = () => {
    searchTerm.value = ''
    expandSearch.value = false
    emit('create-space-for-search-input', false)
    showSearchTooltip.value = false
    const { query } = route
    if (query.q) {
      router.replace({ query: { ...query, q: undefined } })
    }
  }

  const openOrCloseSearch = () => {
    if (route.query.q) {
      searchTerm.value = route.query.q as string
      expandSearch.value = true
    } else {
      searchTerm.value = ''
      expandSearch.value = false
    }
  }

  watch(routeQuery, () => {
    openOrCloseSearch()
  })

  onMounted(() => {
    openOrCloseSearch()
  })

return { __sfc: true,emit, props, router, route, isMobileDevice, isSmallerMobileDevice, contentTermSearched, closeIcon, searchIcon, searchTerm, hovering, expandSearch, showSearchTooltip, searchingFromSidePanel, searchInput, routeQuery, findSearchTerm, checkToShowSearchTooltip, expandSearchInput, clearSearch, openOrCloseSearch, computed, onMounted, ref, watch, SVGRenderer, useBreakpoint, useSegment, useIcons, useRoute, useRouter, vOnClickOutside }
}

})